import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content-grid content-grid--subpage" }

import Breadcrumbs from "@/components/layout/Breadcrumbs.vue";
import BackLinkTitle from "@/components/layout/BackLinkTitle.vue";
import BookForm from "@/components/books/BookForm.vue";
import Card from "@/components/layout/Card.vue";
import {useI18n} from "vue3-i18n";
import {Book} from "@/types/entities";
import {notifyError, notifySuccess} from "@/notify";
import {useBookService} from "@/inversify.config";
import {ICreateBookRequest} from "@/types/requests/createBookRequest";
import {useRouter} from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'AdminAddBookForm',
  setup(__props) {

const {t} = useI18n()
const router = useRouter();
const bookService = useBookService();

async function handleSubmit(book : Book) {
    let succeededOrNotResponse = await bookService.createBook(book as ICreateBookRequest)
    if (succeededOrNotResponse && succeededOrNotResponse.succeeded) {
        notifySuccess(t('validation.book.add.success'))
        setTimeout(() => {
            router.back();
        }, 1500);
    } else {
        let errorMessages = succeededOrNotResponse.getErrorMessages('validation.book.add');
        if (errorMessages.length == 0)
            notifyError(t('validation.book.add.errorOccurred'))
        else
            notifyError(errorMessages[0])
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Breadcrumbs, {
      title: _unref(t)(`routes.admin.children.books.add.name`)
    }, null, 8, ["title"]),
    _createVNode(BackLinkTitle, {
      title: _unref(t)(`routes.admin.children.books.add.name`)
    }, null, 8, ["title"]),
    _createVNode(Card, null, {
      default: _withCtx(() => [
        _createVNode(BookForm, { onFormSubmit: handleSubmit })
      ]),
      _: 1
    })
  ]))
}
}

})